<template>
  <standard-dialog
    v-model="model"
    :title="formTitle"
    :subtitle="editedItem.id ? `ID: ${editedItem.id}` : ''"
    icon="mdi-warehouse"
    max-width="500"
    :save-text="$t('save')"
    :loading="loading"
    :disabled="!valid"
    @save="save"
  >
    <v-form ref="form" v-model="valid">
      <text-field
        v-model="editedItem.name"
        :label="$t('title')"
        required
        :rules="[rules.required]"
      />
      <text-field v-model="editedItem.location" :label="$t('address')" />
      <text-field v-model="editedItem.notes" :label="$t('note')" />
    </v-form>
  </standard-dialog>
</template>

<script>
import hasModel from "@/mixins/hasModel";
import hasValidation from "@/mixins/hasValidation";
import hasSnackbar from "@/mixins/hasSnackbar";
import warehouseService from "@/services/warehouse";
import StandardDialog from "@/components/dialogs/StandardDialog.vue";

export default {
  name: "WarehouseDialog",
  components: {
    StandardDialog,
  },
  mixins: [hasModel, hasValidation, hasSnackbar],
  props: {
    editedItem: {
      type: Object,
      default: () => ({
        id: "",
        name: "",
        location: "",
        notes: "",
      }),
    },
  },
  data: () => ({
    loading: false,
  }),
  computed: {
    formTitle() {
      return this.editedItem.id ? this.$t("edit_warehouse") : this.$t("new_warehouse");
    },
  },
  methods: {
    save() {
      this.loading = true;
      this.editedItem.id ? this.update() : this.create();
    },
    create() {
      const promise = warehouseService.createWarehouse(this.editedItem).then((res) => {
        this.$emit("create", res.data);
        this.model = false;
      });
      this.handleRequest(promise, {
        successMessage: this.$t("warehouse_created_success"),
        errorMessagePrefix: this.$t("warehouse_create_error_prefix"),
      }).finally(() => {
        this.loading = false;
      });
    },
    update() {
      const promise = warehouseService
        .updateWarehouse(this.editedItem.id, this.editedItem)
        .then((res) => {
          this.$emit("update", res.data);
          this.model = false;
        });
      this.handleRequest(promise, {
        successMessage: this.$t("warehouse_updated_success"),
        errorMessagePrefix: this.$t("warehouse_update_error_prefix"),
      }).finally(() => {
        this.loading = false;
      });
    },
  },
};
</script>
